module.exports = __webpack_public_path__ + "img/gearHelper_b.03c983b0.svg";